import { render, staticRenderFns } from "./TrainingNutrition.vue?vue&type=template&id=0f635ad6&scoped=true&"
import script from "./TrainingNutrition.vue?vue&type=script&lang=js&"
export * from "./TrainingNutrition.vue?vue&type=script&lang=js&"
import style0 from "./TrainingNutrition.vue?vue&type=style&index=0&id=0f635ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f635ad6",
  null
  
)

export default component.exports